<div class="menu-overlay">
    <ng-container *ngFor="let link of menu">
        <ng-container *ngTemplateOutlet="link?.children?.length > 0 ? linkWithLinks : linkWithoutLinks; context: { $implicit: link, oddEven:'even' }"> </ng-container>
    </ng-container>
</div>
<ng-template #linkWithLinks
             let-context
             let-oddEven="oddEven">
    <span class="section">
        <span class="title">{{ context?.title }}</span>
        <div [class]="oddEven">
            <ng-container *ngFor="let link of context?.children">
                <ng-container *ngTemplateOutlet="link?.children?.length > 0 ? linkWithLinks : linkWithoutLinks; context: { $implicit: link, oddEven: oddEven === 'odd' ? 'even' : 'odd' }"> </ng-container>
            </ng-container>
        </div>
        <a class="link"
           [routerLink]="context?.link"
           *ngIf="context?.link">{{ 'MENU.ALL_OF' | translate:{title: context?.title} }}
            <app-svg class="chevron"
                     use="chevron-right"></app-svg>
        </a>
    </span>
</ng-template>
<ng-template #linkWithoutLinks
             let-context>
    <a [routerLink]="context.link"
       *ngIf="context?.media == null; else menuContent">{{ context?.title }}</a>
    <ng-template #menuContent>
        <span class="section">
            <img class="content-media"
                 [use]="context?.media"
                 [alt]="context?.media?.alt"
                 auto="none"
                 [query]="{width:250,height:250}">
            <span class="content-title">{{ context?.title }}</span>
            <span class="content-text">{{ context?.description }}</span>
        </span>
    </ng-template>
</ng-template>
